declare global {
  interface Window {
    __settlewise_session_id?: string;
  }
}

// Track critical path events to PostHog.
// All critical path events MUST go through this function to ensure
// consistent global properties.

import { trackEvent } from '@/lib/posthog';
import posthog from 'posthog-js';

const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

function getSessionId(): string {
  try {
    const phSessionId = posthog.get_session_id?.();
    if (phSessionId) return phSessionId;
  } catch {
    // PostHog not initialized yet
  }
  // Fallback: generate per-tab session ID
  if (!window.__settlewise_session_id) {
    window.__settlewise_session_id = crypto.randomUUID();
  }
  return window.__settlewise_session_id;
}

function getGlobalProperties(): Record<string, unknown> {
  return {
    session_id: getSessionId(),
    app_version: APP_VERSION,
    platform: 'web' as const,
    timestamp: new Date().toISOString(),
  };
}

/**
 * Track a critical path event to PostHog.
 * Automatically attaches global properties (session_id, app_version, platform, timestamp).
 */
export function trackCriticalEvent(
  eventData: { event: string; properties: Record<string, unknown> },
): void {
  const enrichedProperties = {
    ...getGlobalProperties(),
    ...eventData.properties,
  };

  trackEvent(eventData.event, enrichedProperties);
}
